<template>
  <div class="m-address-form row no-gutters">
    <base-input
      v-if="displayNameInput"
      v-model="value.fullName"
      v-validate="'required'"
      class="-with-validation"
      type="text"
      :label="$t('billingInformationFullName', 'Fulde navn')"
      :name="`${validationScope}-address-form-full-name`"
      :error-message="$t('billingInformationFullNameErrorMsg', 'Indtast venligst dit fulde navn')"
      :aria-label="$t('billingInformationFullName', 'Fulde navn')"
      show-feedback-icon
      required
      :data-vv-scope="validationScope"
      @input="$emit('update-field', 'fullName', $event)"
    />
    <base-input
      v-model="value.address"
      v-validate="'required'"
      class="-with-validation"
      type="text"
      :label="$t('addressFormAddress', 'Adresse')"
      :name="`${validationScope}-address-form-address`"
      :error-message="$t('addressFormAddressErrorMsg', 'Indtast venligst din adresse')"
      :aria-label="$t('addressFormAddress', 'Adresse')"
      show-feedback-icon
      required
      :data-vv-scope="validationScope"
      :disabled="isAddressDisabled"
      :max-input-length="50"
      @input="$emit('update-field', 'address', $event)"
    />
    <div class="col-5 col-sm-3 col-md-2 col-lg-3 col-lx-2">
      <base-input
        v-model="value.zipCode"
        v-validate="'required'"
        class="-with-validation"
        type="text"
        :label="$t('addressFormZipCode', 'Postnummer')"
        :name="`${validationScope}-address-form-zip-code`"
        :error-message="$t('addressFormZipCodeErrorMsg', 'Indtast venligst et gyldigt postnummer')"
        :aria-label="$t('addressFormZipCode', 'Postnummer')"
        show-feedback-icon
        required
        :data-vv-scope="validationScope"
        :disabled="isZipcodeDisabled"
        @input="debounceValidateZipCode"
      />
    </div>
    <div class="col-7 col-sm-9 col-md-10 col-lg-9 col-lx-10 pl-4">
      <base-input
        v-model="value.city"
        class="-with-validation"
        type="text"
        :label="$t('addressDeliveryCity', 'By')"
        :name="`${validationScope}-address-form-city`"
        :aria-label="$t('addressDeliveryCity', 'By')"
        :placeholder="$t('addressDeliveryCityPlaceholder', '')"
      />
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/atoms/BaseInput.vue';
import debounce from 'debounce';

export default {
  name: 'AddressForm',
  inject: ['$validator'],
  components: {
    BaseInput
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    validationScope: {
      type: String,
      required: true
    },
    accountInformationSet: {
      type: Boolean,
      default: false
    },
    displayNameInput: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isAddressDisabled: this.accountInformationSet && this.value.address !== '',
      isZipcodeDisabled: this.accountInformationSet && this.value.zipCode !== ''
    }
  },
  methods: {
    activateInvalidZipCode (zipCode) {
      this.$emit('update-field', 'zipCode', zipCode);
      this.$emit('update-field', 'city', '');

      const alreadyHasError = this.$validator.errors.has(`${this.validationScope}-address-form-zip-code`);
      if (!alreadyHasError) {
        this.$validator.errors.add({
          field: `${this.validationScope}-address-form-zip-code`,
          msg: 'Zip code invalid',
        });
      }
    },
    debounceValidateZipCode: debounce(async function (zipCode) {
      if (zipCode.length !== 4) {
        this.activateInvalidZipCode(zipCode);
        return;
      }

      try {
        // NOTICE! Disabled because dataforsyningen.dk is down!
        // const { data } = await this.$axios(`https://api.dataforsyningen.dk/postnumre/${zipCode}`);
        this.$emit('update-field', 'zipCode', zipCode);
        // this.$emit('update-field', 'city', data.navn);
        this.$validator.errors.remove(`${this.validationScope}-address-form-zip-code`);
      } catch {
        this.activateInvalidZipCode(zipCode);
      }
    }, 200)
  }
}
</script>
